import { z } from 'zod';

export const PushChannelSchema = z.enum([
  'temperature_alerts',
  'documents',
  'expirations',
  'cleaning_tasks',
  'system',
]);
export type PushChannel = z.infer<typeof PushChannelSchema>;

export const PushPrioritySchema = z.enum(['low', 'normal', 'high']);
export type PushPriority = z.infer<typeof PushPrioritySchema>;

export const PushNotificationSchema = z.object({
  channel: PushChannelSchema,
  priority: PushPrioritySchema.default('normal'),
  title: z.string().max(200),
  body: z.string().max(500),
  deep_link: z.string().max(500).nullable().optional(),
  data: z.record(z.unknown()).nullable().optional(),
});
export type PushNotification = z.infer<typeof PushNotificationSchema>;

export interface NotificationProvider {
  registerDevice(input: {
    user_id: string;
    device_token: string;
    platform: 'ios' | 'android' | 'web';
  }): Promise<void>;
  unregisterDevice(device_token: string): Promise<void>;
  sendToUser(user_id: string, notification: PushNotification): Promise<{ sent: number }>;
  sendToTenant(
    tenant_id: string,
    channel: PushChannel,
    notification: PushNotification,
  ): Promise<{ sent: number }>;
}
